import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameSubForm, Schema as NameSchema } from '../subforms/Name';
import { PersonalDataSubForm, Schema as PersonalDataSchema } from '../subforms/PersonalData';
import { ContactSubForm, Schema as ContactSchema } from '../subforms/ContactApprentice';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { DocumentsDiplomaSubForm, Schema as DocumentsDiplomaSchema } from '../subforms/DocumentsDiploma';
import { AdditionalConsentSubForm } from '../subforms/AdditionalConsent';

export const BBBankAuszubildendeSchema = (settings) => (
    Yup.object()
        .concat(NameSchema(settings))
        .concat(PersonalDataSchema(settings))
        .concat(ContactSchema(settings))
        .concat(OtherInformationSchema)
        .concat(DocumentsDiplomaSchema(settings))
);

export const BBBankAuszubildende = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameSubForm} colors={colors} settings={settings} />
            <Field component={PersonalDataSubForm} colors={colors} settings={settings} />
            <Field component={ContactSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} />
            <Field component={DocumentsDiplomaSubForm} colors={colors} settings={settings} />
            <Field component={AdditionalConsentSubForm} />
        </>
    );
}